import { DOCUMENT_CATEGORY_LABELS } from './document-category-labels';
import type { Messages } from '../index';

/**
 * en-US sibling of the document copy. Shape is constrained by `Messages['documents']`.
 */
export const documents: Messages['documents'] = {
  'signature-pages': {
    'signatures-heading': 'Signatures',
    'role-agency': 'for {companyName}',
    'role-owner': 'Owner',
    'signed-at': 'Electronically signed on {date} at {time}',
    'signatures-footer': 'Signatures · Page {page}',
    'proof-heading': 'Proof',
    'proof-email': 'Email: {email}',
    'proof-signed': 'Signed: {date} {time} ({zone})',
    'proof-ip': 'IP address: {ip}',
    'proof-browser': 'Browser: {userAgent}',
    'proof-browser-unknown': 'unknown',
    'proof-early-start': 'Early start requested: {value, select, yes {yes} other {no}}',
    'proof-fingerprint': 'Document fingerprint (SHA-256): {hash}',
    'proof-footer': 'Proof · Page {page}',
  },
  'deal-document': {
    months: '{months, plural, one {# month} other {# months}}',
    'broker-representation':
      '{count, plural, one {the authorised broker {names}} other {the authorised brokers {names}, each with sole power of representation}}',
    'page-number': 'Page {page} / {pages}',
    'footer-separator': ' · ',
    'signed-suffix': 'signed',
    type: {
      BROKER_CONTRACT: DOCUMENT_CATEGORY_LABELS.BROKER_CONTRACT,
      POWER_OF_ATTORNEY: DOCUMENT_CATEGORY_LABELS.POWER_OF_ATTORNEY,
    },
  },
};
